module.exports = __webpack_public_path__ + "static/img/const-content-5.29bfe8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/const-content-5.png
// module id = 4QAK
// module chunks = 0